import * as React from 'react';

export function SvgLiveWeightStatusIconConnected(props) {
  return (
    <svg
      height='1em'
      viewBox='-7 -16 90 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8.148 2.877H.971V.197h7.177v2.68zm11.148 0h-7.178V.197h7.178v2.68zm11.147 0h-7.177V.197h7.177v2.68zm11.148 0h-7.178V.197h7.178v2.68z'
        fill='#30424B'
      />
      <text fill='#000' x='50' y='10'>
        {props.uom}
      </text>
    </svg>
  );
}

export function SvgLiveWeightStatusIconNotReady(props) {
  return (
    <svg height='1em' viewBox='0 0 60 33' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M22.148 18.877h-7.177v-2.68h7.177v2.68zm11.148 0h-7.178v-2.68h7.178v2.68zm11.147 0h-7.177v-2.68h7.177v2.68zM29.773 24.5c.62 0 1.099.178 1.436.533.337.347.506.784.506 1.313 0 .52-.169.952-.506 1.299-.337.337-.816.505-1.436.505-.592 0-1.061-.168-1.408-.505-.346-.338-.52-.77-.52-1.3 0-.528.17-.965.507-1.312.337-.355.81-.533 1.421-.533z'
        fill='#1A2D38'
      />
    </svg>
  );
}

export function SvgLiveWeightStatusIconOverweight(props) {
  return (
    <svg
      height='1em'
      viewBox='0 -3 60 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M29.773 17.5c.62 0 1.099.178 1.436.533.337.347.506.784.506 1.313 0 .52-.169.952-.506 1.299-.337.337-.816.505-1.436.505-.592 0-1.061-.168-1.408-.505-.346-.338-.52-.77-.52-1.3 0-.528.17-.965.507-1.312.337-.355.81-.533 1.421-.533zM6.701 14.26l-2.783 7.061h-2.52l4.38-10.65h1.86l4.366 10.65H9.499l-2.798-7.06zm12.54 0l-2.784 7.061h-2.52l4.38-10.65h1.86l4.366 10.65h-2.505l-2.798-7.06zM40.701 14.26l-2.783 7.061h-2.52l4.38-10.65h1.86l4.366 10.65h-2.505l-2.798-7.06zm12.54 0l-2.784 7.061h-2.52l4.38-10.65h1.86l4.366 10.65h-2.505l-2.798-7.06z'
        fill='#1A2D38'
      />
    </svg>
  );
}

export function SvgLiveWeightStatusIconUnderweight(props) {
  return (
    <svg
      height='1em'
      viewBox='-3 -13 60 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M5.436 8.691L7.896.377h2.696L6.563 12H4.297L.237.377h2.706l2.493 8.314zm12.025 0l2.46-8.314h2.696L18.59 12h-2.266L12.262.377h2.707l2.492 8.314zm7.75.559c.487 0 .863.14 1.128.419.265.272.398.616.398 1.031 0 .408-.133.749-.398 1.02-.265.266-.64.398-1.128.398-.465 0-.834-.132-1.106-.397-.272-.265-.408-.605-.408-1.02 0-.416.132-.76.397-1.032.265-.28.637-.419 1.117-.419zm9.748-.559L37.42.377h2.697L36.087 12h-2.266L29.76.377h2.706l2.492 8.314zm12.026 0l2.46-8.314h2.696L48.113 12h-2.267L41.786.377h2.707l2.492 8.314z'
        fill='#1A2D38'
      />
    </svg>
  );
}

export function SvgLiveWeightStatusIconUnstable(props) {
  return (
    <svg
      height='1em'
      viewBox='-3 -15 60 33'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M8.148 2.877H.971V.197h7.177v2.68zm11.148 0h-7.178V.197h7.178v2.68zM26.068 6.5c.62 0 1.099.178 1.436.533.337.347.506.784.506 1.313 0 .52-.169.952-.506 1.299-.337.337-.816.505-1.436.505-.592 0-1.061-.168-1.408-.505-.346-.338-.52-.77-.52-1.3 0-.528.17-.965.507-1.312.337-.355.81-.533 1.421-.533zm14.156-3.623h-7.178V.197h7.178v2.68zm11.147 0h-7.178V.197h7.178v2.68z'
        fill='#1A2D38'
      />
    </svg>
  );
}
